import { DEMO_STAND_REGISTER_URL, isDemoStandEnabled } from './demoStand'

export const DemoStandBanner = () => {
  if (!isDemoStandEnabled()) {
    return null
  }

  return (
    <div className="market-demo-banner" role="status">
      Демо-кабинет тарифа «Премиум». Данные обезличены.{' '}
      <a
        className="market-demo-banner__link"
        href={DEMO_STAND_REGISTER_URL}
        target="_blank"
        rel="noreferrer"
      >
        Регистрация открывает 30 дней бесплатно.
      </a>
    </div>
  )
}

